import { Box, Group } from "@mantine/core";
import React from "react";

interface ItemLayoutProps {
  title?: any;
  content?: any;
  bottom?: any;
  style?: any;
  onClick?: any;
}
const ItemLayout = ({
  title,
  content,
  bottom,
  style,
  onClick,
}: ItemLayoutProps) => {
  return (
    <Box
      style={style}
      sx={{
        padding: "12px 16px",
        borderRadius: "8px",
        fontSize: "14px",
        boxShadow: "0px 2px 8px 0px rgba(99, 141, 191, 0.1)",
        ...style,
      }}
      onClick={onClick}
    >
      {/* Title */}
      <Group spacing={12} mb={10}>
        {title}
      </Group>
      {/* Content */}
      <Box sx={{ flex: 1 }}>{content}</Box>
      {bottom}
    </Box>
  );
};

export default ItemLayout;
